import { render, staticRenderFns } from "./SeatSelection.vue?vue&type=template&id=27923ae4&scoped=true"
import script from "./SeatSelection.vue?vue&type=script&lang=js"
export * from "./SeatSelection.vue?vue&type=script&lang=js"
import style0 from "./SeatSelection.vue?vue&type=style&index=0&id=27923ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27923ae4",
  null
  
)

export default component.exports